import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge precisa conhecer os nomes customizados do tema; sem isso `text-body`
 * seria tratado como cor e apagaria `text-ink` (ou vice-versa).
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['micro', 'compact', 'body', 'body-lg', 'section', 'page', 'kpi', 'display'],
      font: ['sans', 'condensed'],
      shadow: ['float'],
      ease: ['entrance', 'state', 'confirm'],
      animate: [
        'spin',
        'pulse',
        'overlay-in',
        'overlay-out',
        'dialog-in',
        'dialog-out',
        'float-in',
        'float-out',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
